/// <reference types="vite/client" />

export const API_BASE = import.meta.env.PROD
  ? 'https://api.housewizrd.com/api/v1'
  : '/api/v1';
